import { render, staticRenderFns } from "./infoView - 副本 (2).vue?vue&type=template&id=07158b0e&scoped=true"
import script from "./infoView - 副本 (2).vue?vue&type=script&lang=js"
export * from "./infoView - 副本 (2).vue?vue&type=script&lang=js"
import style0 from "./infoView - 副本 (2).vue?vue&type=style&index=0&id=07158b0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07158b0e",
  null
  
)

export default component.exports